import { useState } from 'react';
import GeckoFeatures from 'services/gecko-features';

const isMailgunChannel = (channel) => {
  return channel?.type === 'mailgun';
};

const isNotMailgunChannel = (channel) => {
  return !isMailgunChannel(channel);
};

const doesChannelHaveId = (id) => (channel) => {
  return Number(channel.id) === id;
};

const channelMatchesFilterText = (filterText, channel) => {
  if (!channel.name) {
    return false;
  }
  const normalisedChannelName = channel.name.toLowerCase();
  const normalisedFilterText = filterText.toLowerCase();
  return normalisedChannelName.includes(normalisedFilterText);
};

export function useChannelSelectorLogic(props) {
  const {
    hidden,
    noteMode,
    noteChannelId,
    channels,
    onChannelSelected,
    selectedChannel,
    isPickingInitialChannel,
    includeFormProp,
  } = props;

  const [isSelectorOpen, setIsSelectorOpen] = useState(false);
  const [filterText, setFilterText] = useState('');

  const toggleSelectorOpen = () => setIsSelectorOpen(!isSelectorOpen);

  const isNoteChannel = doesChannelHaveId(noteChannelId);

  const isSelectedChannel = (channel) => {
    if (!selectedChannel) {
      return false;
    }
    return channel.id === selectedChannel.id;
  };

  const isPickableChannel = (channel) => {
    if (isNoteChannel(channel)) {
      return false;
    }
    if (isSelectedChannel(channel)) {
      return false;
    }
    if (
      isMailgunChannel(selectedChannel) &&
      isNotMailgunChannel(channel)
    ) {
      return false;
    }
    return channelMatchesFilterText(filterText, channel);
  };

  const pickableChannels = channels.filter(isPickableChannel);

  const selectChannelAndResetState = (newChannel) => {
    setIsSelectorOpen(false);
    onChannelSelected(newChannel);
    setFilterText('');
  };

  const doesChannelStartANewConversation = (channel) => {
    if (isPickingInitialChannel) {
      return false;
    }
    return isMailgunChannel(channel);
  };

  const doesChannelReplyOnExistingConversation = (channel) => {
    return !doesChannelStartANewConversation(channel);
  };

  const newConversationChannels = pickableChannels.filter(
    doesChannelStartANewConversation
  );
  const replyViaChannels = pickableChannels.filter(
    doesChannelReplyOnExistingConversation
  );

  const hasNoPickableChannels =
    newConversationChannels.length === 0 && replyViaChannels.length === 0;

  const isSelectorHidden = hidden || noteMode.on || channels.length < 2;

  return {
    filterText,
    setFilterText,
    isSelectorHidden,
    isSelectorOpen,
    toggleSelectorOpen,
    newConversationChannels,
    replyViaChannels,
    selectChannel: selectChannelAndResetState,
    selectedChannel,
    hasNoPickableChannels,
    includeFormProp,
  };
}
